export const pushAnalyticsEvent = (event, payload = {}) => {
  if (!window?.dataLayer) return;

  window.dataLayer.push({ event, ...payload });
};

export default pushAnalyticsEvent;
